export default "__VITE_ASSET__CHOzy7MI__"